export { default } from './MedicationAssociation';
